const localhost = "http://192.168.100.24:8000"
const webSockethost = "ws://localhost:8001"


// const localhost = "http://192.168.1.241:8000"
// const webSockethost = "ws://192.168.1.241:8000"


// export const mocalhost = "http://192.168.1.102:8000"
// const localhost = "http://localhost:8000"
// const localhost = "http://localhost:8000"

// export const mocalhost = "http://localhost:8000"

const apiURL = "/api"
const endpoint = `${localhost}${apiURL}`

// scaleWeightWebSocketURL


export const loginURL = `${endpoint}/users/loginUser/`;
export const createUserURL = `${endpoint}/users/createUser/`;
export const activateUserURL = `${endpoint}/users/activateUser/`;
export const logoutUserURL = `${endpoint}/users/logoutUser/`;
export const usersURL = `${endpoint}/users/users/`;
export const suspendedUsersURL = `${endpoint}/users/suspendedUsers/`;
export const statitionUsersURL = `${endpoint}/users/statitionUsers/`;
export const stationSuspendedUsersURL = `${endpoint}/users/stationSuspendedUsers/`;
export const suspendSystemUserURL = `${endpoint}/users/suspendSystemUser/`;
export const unsuspendSystemUserURL = `${endpoint}/users/unsuspendSystemUser/`;
export const registerSystemUserURL = `${endpoint}/users/registerSystemUser/`;
export const updateSystemUserPasswordURL = `${endpoint}/users/updateSystemUserPassword/`;
export const updateSystemUserURL = `${endpoint}/users/updateSystemUser/`;

export const countriesURL = `${endpoint}/places/countries/`;
export const provincesURL = `${endpoint}/places/provinces/`;
export const deletedProvincesURL = `${endpoint}/places/deletedProvinces/`;
export const countryProvincesURL = `${endpoint}/places/countryProvinces/`;
export const createProvinceURL = `${endpoint}/places/createProvince/`;
export const updateProvinceURL = `${endpoint}/places/updateProvince/`;
export const deleteProvinceURL = `${endpoint}/places/deleteProvince/`;
export const activateProvinceURL = `${endpoint}/places/activateProvince/`;
export const localAuthoritiesURL = `${endpoint}/places/localAuthorities/`;
export const deletedLocalAuthoritiesURL = `${endpoint}/places/deletedLocalAuthorities/`;
export const createLocalAuthorityURL = `${endpoint}/places/createLocalAuthority/`;
export const updateLocalAuthorityURL = `${endpoint}/places/updateLocalAuthority/`;
export const deleteLocalAuthorityURL = `${endpoint}/places/deleteLocalAuthority/`;
export const activateLocalAuthorityURL = `${endpoint}/places/activateLocalAuthority/`;
export const districtMeteredAreasURL = `${endpoint}/places/districtMeteredAreas/`;              
export const deletedDistrictMeteredAreasURL = `${endpoint}/places/deletedDistrictMeteredAreas/`;              
export const createDistrictMeteredAreaURL = `${endpoint}/places/createDistrictMeteredArea/`;              
export const updateDistrictMeteredAreaURL = `${endpoint}/places/updateDistrictMeteredArea/`;              
export const deleteDistrictMeteredAreaURL = `${endpoint}/places/deleteDistrictMeteredArea/`;              
export const activateDistrictMeteredAreaURL = `${endpoint}/places/activateDistrictMeteredArea/`;              
export const reservoirZonesURL = `${endpoint}/places/reservoirZones/`;              
export const deletedReservoirZonesURL = `${endpoint}/places/deletedReservoirZones/`;              
export const createReservoirZoneURL = `${endpoint}/places/createReservoirZone/`;              
export const updateReservoirZoneURL = `${endpoint}/places/updateReservoirZone/`;              
export const deleteReservoirZoneURL = `${endpoint}/places/deleteReservoirZone/`; 
export const activateReservoirZoneURL = `${endpoint}/places/activateReservoirZone/`;      
         
export const suburbsURL = `${endpoint}/places/suburbs/`;              
export const deletedSuburbsURL = `${endpoint}/places/deletedSuburbs/`;              
export const createSuburbURL = `${endpoint}/places/createSuburb/`;              
export const updateSuburbURL = `${endpoint}/places/updateSuburb/`;   
export const deleteSuburbURL = `${endpoint}/places/deleteSuburb/`;   
export const activateSuburbURL = `${endpoint}/places/activateSuburb/`;  
export const addressesURL = `${endpoint}/places/addresses/`;  
export const deletedAddressesURL = `${endpoint}/places/deletedAddresses/`;  
export const createAddressURL = `${endpoint}/places/createAddress/`;  
export const updateAddressURL = `${endpoint}/places/updateAddress/`;  
export const deleteAddressURL = `${endpoint}/places/deleteAddress/`;  
export const activateAddressURL = `${endpoint}/places/activateAddress/`; 

export const waterSourcesURL = `${endpoint}/infrastructure/waterSources/`; 
export const deletedWaterSourcesURL = `${endpoint}/infrastructure/deletedWaterSources/`; 
export const createWaterSourceURL = `${endpoint}/infrastructure/createWaterSource/`; 
export const updateWaterSourceURL = `${endpoint}/infrastructure/updateWaterSource/`; 
export const deleteWaterSourceURL = `${endpoint}/infrastructure/deleteWaterSource/`; 
export const activateWaterSourceURL = `${endpoint}/infrastructure/activateWaterSource/`; 
export const waterDistributionZonesURL = `${endpoint}/infrastructure/waterDistributionZones/`; 
export const deletedWaterDistributionZonesURL = `${endpoint}/infrastructure/deletedWaterDistributionZones/`; 
export const createWaterDistributionZoneURL = `${endpoint}/infrastructure/createWaterDistributionZone/`; 
export const updateWaterDistributionZoneURL = `${endpoint}/infrastructure/updateWaterDistributionZone/`; 
export const deleteWaterDistributionZoneURL = `${endpoint}/infrastructure/deleteWaterDistributionZone/`; 
export const activateWaterDistributionZoneURL = `${endpoint}/infrastructure/activateWaterDistributionZone/`; 
export const treatmentPlantsURL = `${endpoint}/infrastructure/treatmentPlants/`; 
export const deletedTreatmentPlantsURL = `${endpoint}/infrastructure/deletedTreatmentPlants/`; 
export const createTreatmentPlantURL = `${endpoint}/infrastructure/createTreatmentPlant/`; 
export const updateTreatmentPlantURL = `${endpoint}/infrastructure/updateTreatmentPlant/`; 
export const deleteTreatmentPlantURL = `${endpoint}/infrastructure/deleteTreatmentPlant/`; 
export const activateTreatmentPlantURL = `${endpoint}/infrastructure/activateTreatmentPlant/`; 
export const reservoirsURL = `${endpoint}/infrastructure/reservoirs/`; 
export const deletedReservoirsURL = `${endpoint}/infrastructure/deletedReservoirs/`; 
export const createReservoirURL = `${endpoint}/infrastructure/createReservoir/`; 
export const updateReservoirURL = `${endpoint}/infrastructure/updateReservoir/`; 
export const deleteReservoirURL = `${endpoint}/infrastructure/deleteReservoir/`; 
export const activateReservoirURL = `${endpoint}/infrastructure/activateReservoir/`; 
export const reservoirDMAsURL = `${endpoint}/infrastructure/reservoirDMAs/`; 
export const deletedReservoirDMAsURL = `${endpoint}/infrastructure/deletedReservoirDMAs/`; 
export const createReservoirDMAURL = `${endpoint}/infrastructure/createReservoirDMA/`; 
export const updateReservoirDMAURL = `${endpoint}/infrastructure/updateReservoirDMA/`; 
export const deleteReservoirDMAURL = `${endpoint}/infrastructure/deleteReservoirDMA/`; 
export const activateReservoirDMAURL = `${endpoint}/infrastructure/activateReservoirDMA/`; 
export const pipelineDMAsURL = `${endpoint}/infrastructure/pipelineDMAs/`; 
export const deletedPipelineDMAsURL = `${endpoint}/infrastructure/deletedPipelineDMAs/`; 
export const createPipelineDMAURL = `${endpoint}/infrastructure/createPipelineDMA/`; 
export const updatePipelineDMAURL = `${endpoint}/infrastructure/updatePipelineDMA/`; 
export const deletePipelineDMAURL = `${endpoint}/infrastructure/deletePipelineDMA/`; 
export const activatePipelineDMAURL = `${endpoint}/infrastructure/activatePipelineDMA/`; 
export const pipelineSegmentsURL = `${endpoint}/infrastructure/pipelineSegments/`; 
export const deletedPipelineSegmentsURL = `${endpoint}/infrastructure/deletedPipelineSegments/`; 
export const createPipelineSegmentURL = `${endpoint}/infrastructure/createPipelineSegment/`; 
export const updatePipelineSegmentURL = `${endpoint}/infrastructure/updatePipelineSegment/`; 
export const deletePipelineSegmentURL = `${endpoint}/infrastructure/deletePipelineSegment/`; 
export const activatePipelineSegmentURL = `${endpoint}/infrastructure/activatePipelineSegment/`; 
export const valveDMAsURL = `${endpoint}/infrastructure/valveDMAs/`; 
export const deletedValveDMAsURL = `${endpoint}/infrastructure/deletedValveDMAs/`; 
export const createValveDMAURL = `${endpoint}/infrastructure/createValveDMA/`; 
export const updateValveDMAURL = `${endpoint}/infrastructure/updateValveDMA/`; 
export const deleteValveDMAURL = `${endpoint}/infrastructure/deleteValveDMA/`; 
export const activateValveDMAURL = `${endpoint}/infrastructure/activateValveDMA/`; 
export const valvesURL = `${endpoint}/infrastructure/valves/`; 
export const deletedValvesURL = `${endpoint}/infrastructure/deletedValves/`; 
export const createValveURL = `${endpoint}/infrastructure/createValve/`; 
export const updateValveURL = `${endpoint}/infrastructure/updateValve/`; 
export const deleteValveURL = `${endpoint}/infrastructure/deleteValve/`; 
export const activateValveURL = `${endpoint}/infrastructure/activateValve/`; 


export const waterSourceLevelsURL = `${endpoint}/readings/waterSourceLevels/`;
export const waterSourceLevelsForSourceURL = `${endpoint}/readings/waterSourceLevelsForSource/`;
export const sourcesDatatableURL = `${endpoint}/readings/sourcesDatatable/`;
export const damLevelsForCalendarURL = `${endpoint}/readings/damLevelsForCalendar/`;
export const damsMapURL = `${endpoint}/readings/damsMap/`;
export const inflowChartDataURL = `${endpoint}/readings/inflowChartData/`;
export const damLevelStatsURL = `${endpoint}/readings/damLevelStats/`;













